import { useLocation } from '@tanstack/react-location';
import React from 'react';
import { CheckEmailForm } from './auth-modal/check-email-form';
import { ChooseNewPasswordForm } from './auth-modal/choose-new-password-form';
import { LoginForm } from './auth-modal/login-form';
import { RequestVerificationCodeForm } from './auth-modal/request-verification-code-form';
import { Modal } from './portal';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const HASH_URLS = {
  CHECK_EMAIL: '',
  LOGIN: 'login',
  RESET_PASSWORD: 'reset-password',
  CHOOSE_PASSWORD: 'choose-password',
};

const AuthModal = React.memo(({ isOpen, onClose }: ModalProps): JSX.Element => {
  const location = useLocation();

  const form = (): JSX.Element => {
    switch (location.current?.hash) {
      case HASH_URLS.CHECK_EMAIL:
        return <CheckEmailForm />;
      case HASH_URLS.LOGIN:
        return <LoginForm />;
      case HASH_URLS.RESET_PASSWORD:
        return <RequestVerificationCodeForm />;
      case HASH_URLS.CHOOSE_PASSWORD:
        return <ChooseNewPasswordForm />;
    }
    return <></>;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {form()}
    </Modal>
  );
});

export default AuthModal;
